import { useMemo } from "react";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import usePathPickProductCardView from "@/features/pathpick/hooks/usePathPickProductCardView";
import { PathPickCollection } from "@/features/pathpick/types";

export interface PathPickCollectionOption {
  value: PathPickCollection;
  label: string;
}

// 상품 유형(collection__in) 옵션 — 상단 버튼과 상세 필터의 상품 유형 섹션이 같은 목록을 쓴다.
// KREAM·POIZON 매칭은 카드의 비교 정보와 짝이라 비교 표시를 끄면 함께 내린다.
// (걸려 있던 값은 usePathPickProductFilter가 같은 기준으로 떨어뜨린다)
const usePathPickCollectionOptions = (): PathPickCollectionOption[] => {
  const { t } = useI18nHelper();
  const { isComparisonVisible } = usePathPickProductCardView();

  return useMemo(
    () => [
      {
        value: "HOT_DEAL",
        label: t("path_pick:filter.collection_hot_deal"),
      },
      ...(isComparisonVisible
        ? ([
            {
              value: "KREAM_MATCHED",
              label: t("path_pick:filter.collection_kream_matched"),
            },
            {
              value: "POIZON_MATCHED",
              label: t("path_pick:filter.collection_poizon_matched"),
            },
          ] as PathPickCollectionOption[])
        : []),
      {
        value: "FAVORITE_BRAND",
        label: t("path_pick:filter.collection_favorite_brand"),
      },
    ],
    [t, isComparisonVisible]
  );
};

export default usePathPickCollectionOptions;
